import { render, staticRenderFns } from "./ReviewOne.vue?vue&type=template&id=1ed26279&"
import script from "./ReviewOne.vue?vue&type=script&lang=js&"
export * from "./ReviewOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports